$(document).ready(function() {

    // Overwrite the tabs functionality so that they work like anchor links.
    $(document.body).on('click', 'a.tab-title', function(e) {
        var id = $(e.target).closest('a').attr('href');
        const offsetTop = $(id).offset().top
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: offsetTop - 80,
        })
    });

});
